<template>
  <div class="bg-white">
    <Breadcrumbs current-page-name="Contact Us" />

    <div class="py-[40px] md:py-[0px] -mt-10">
      <GorgiasContactForm class="m-auto md:w-1/2 px-[20px]" />
    </div>

    <div class="py-5 pb-16 px-[20px]">
      <div class="max-w-screen-xs mx-auto flex flex-col gap-y-3 items-center justify-center">
        <div class="inline-flex justify-center items-center gap-x-6">
          <a :key="index" :href="social.url" target="_blank" v-for="(social, index) in socialIcons">
            <component
              :is="social.icon.svg"
              :fill1="social.icon.fill1"
              class="size-8 cursor-pointer" />
          </a>
        </div>

        <p class="paragraph-1">Suite 2.01, 50 York St, Sydney, NSW 2000</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue'
import GorgiasContactForm from '@/components/BrandComponents/ContactUs/GorgiasContactForm.vue'
import TwitterIcon from '@/components/icons/Socials/TwitterIcon.vue'
import FBIcon from '@/components/icons/Socials/FBIcon.vue'
import LinkedInIcon from '@/components/icons/Socials/LinkedInIcon.vue'
import { useHead } from '@unhead/vue'
import { createStandardMeta, addStructuredData, createBreadcrumbSchema, createOrganizationSchema } from '@/utils/seo'
import { createContactPageSchema } from '@/utils/schemas'

// SEO for contact page
const seoData = createStandardMeta({
  title: 'Contact Otivo for Financial Advice Support | Otivo',
  description: 'Get in touch with Otivo\'s team for support, advice, or general enquiries. Find the right contact method for your financial needs.',
  keywords: 'contact otivo, financial advice support, customer service, help'
})

const structuredData = addStructuredData([
  createOrganizationSchema(),
  createContactPageSchema(),
  createBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'About', url: '/about' },
    { name: 'Contact Us' }
  ])
])

useHead({
  ...seoData,
  ...structuredData
})

const socialIcons = [
  {
    icon: {
      svg: TwitterIcon,
      fill1: 'primary',
    },
    url: 'https://twitter.com/OtivoFinancial',
  },
  {
    icon: {
      svg: FBIcon,
      fill1: 'primary',
    },
    url: 'https://www.facebook.com/OtivoFinancial',
  },
  {
    icon: {
      svg: LinkedInIcon,
      fill1: 'primary',
    },
    url: 'https://www.linkedin.com/company/otivo/',
  },
]
</script>
